<template>
  <div>
    <b-card class="standardpage">

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="zhold_reset">*EVENTS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-orange">{{ ztotal }}</span>
        </b-nav-item>
        <!-- {{ zholdevents }} -->
        <b-nav-item v-if="zevent.eventcode" class="nav-pills-hover-effect border-secondary" small
          v-for="(zevent, index) in zholdevents" :key="zevent"
          @click="agent = null; slac = [], eventcode = [zevent.eventcode]" :active="zevent.eventcode == eventcode[0]">
          <span :id="'event_name_' + index" :class="zevent.eventcode == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zevent.eventcode"></span>
          <span :id="'event_count_' + index" class="ml-1 badge badge-orange">{{ zevent.count }}</span>

          <span v-if="parseFloat(zevent.aged) > 0" :id="'event_aged_' + index" class="ml-1 badge badge-danger">{{
            zevent.aged }}</span>

          <b-tooltip :target="'event_name_' + index" placement="top">{{ zevent.name }}</b-tooltip>

          <b-tooltip :target="'event_count_' + index" placement="top">{{ zevent.count }} ticket(s) in
            total.</b-tooltip>

          <b-tooltip :target="'event_aged_' + index" placement="top">{{ zevent.aged }} ticket(s) have been delayed in
            Zhold for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <hr />

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="zhold_reset">*SLACS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-orange">{{ ztotal }}</span>
        </b-nav-item>
        <b-nav-item v-if="zclient.slac" class="nav-pills-hover-effect border-secondary" small
          v-for="(zclient, index) in zholdclients" :key="zclient"
          @click="agent = null; eventcode = []; slac = [zclient.slac]" :active="zclient.slac == slac[0]">
          <span :id="'zhold_name_' + index" :class="zclient.slac == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zclient.slac"></span>

          <!-- <span class="ml-1 badge badge-orange">{{ zclient.count }} /<span :id="'zhold_client_' + index"
                class="ml-1 badge badge-danger">{{ zclient.aged }}</span></span> -->
          <span :id="'zhold_count_' + index" class="ml-1 badge badge-orange">{{ zclient.count }}</span>
          <!-- /<span class="pl-1">/</span> -->
          <span v-if="parseFloat(zclient.aged) > 0" :id="'zhold_aged_' + index" class="ml-1 badge badge-danger">{{
            zclient.aged }}</span>

          <b-tooltip :target="'zhold_name_' + index" placement="top">{{ zclient.name }}</b-tooltip>

          <b-tooltip :target="'zhold_count_' + index" placement="top">{{ zclient.count }} ticket(s) in total in
            Zhold.</b-tooltip>
          <b-tooltip :target="'zhold_aged_' + index" placement="top">{{ zclient.aged }} ticket(s) have been delayed in
            Zhold for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <b-card-header class="pt-2 pb-2">
        <!-- <b-row>
          <b-col cols="auto" v-if="slac.length == 0">
            <span class="badge badge-orange text-2x pt-0 pb-1">Select an event or client SL A/C code to view Zhold tickets</span>
          </b-col>
          <b-col class="text-right strong"> Total:
            <span id="zhold_ztotal" class="ml-1 badge badge-orange text-3x pt-0 pb-1">{{ ztotal }}</span>
            <b-tooltip target="zhold_ztotal" placement="top">Total of uninvoiced ticket(s) waiting in Zhold.</b-tooltip>
          </b-col>
        </b-row> -->

        <b-row align-v="center">
          <b-col cols="auto" v-if="!zholdagents.find(o => o.agent == agent)">
            <span class="badge badge-orange text-2x pt-0 pb-1 ml-0">Select an agent to view inventory
              <!-- <span v-if="user.permissions.includes('zagents.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span> -->
            </span>

          </b-col>
          <b-col cols="auto" class="text-right" v-else>

            <span class="badge badge-orange text-2x pt-0 pb-1"> {{zholdagents.find(o => o.agent ==
              agent) ? zholdagents.find(o => o.agent == agent).name : ""}}
              <!-- <span v-if="user.permissions.includes('conferma.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span> -->
            </span>

          </b-col>

          <b-col align-self="center" class="text-right" style="padding-top:10px">
            <b-row align-h="end" no-gutters>
              <b-col cols="auto"><i class="fa fa-square text-primary" ></i><span class="text-secondary pl-1">Zhold</span> </b-col>
              <b-col cols="auto" class="mx-2"><i class="fa fa-square text-zhold_priced"></i><span class="text-secondary pl-1">Priced</span> </b-col>
              <b-col cols="auto"><i class="fa fa-square text-zhold_fee"></i><span class="text-secondary pl-1 ">Fee</span> </b-col>
            </b-row>
          </b-col>
          
          <b-col cols="auto" class="text-right strong">
            Count:
            <span id="ihold_ztotal" class="ml-1 badge badge-orange text-3x pt-0 pb-1">{{ ztotal }}</span>
            <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced ticket(s) waiting in Zhold.</b-tooltip>
          </b-col>
        </b-row>

      </b-card-header>

      <div v-if="!component" class="mt-4 availtable datatable">
        <!-- {{ zholdagents }} -->
        <b-row>
          <b-col>
            <b-avatar-group v-for="(zdepartment, gindex) in departments" :key="gindex" size="34px" overlap="0"
              class="inline mr-1 mt-1 ml-2 text-center p-1 avatar_dept avatarbadge">
              <span class="text-primary pt-2 mr-1">{{ zdepartment }}</span>
              <!-- border-secondary px-2 strong -->
              <div v-for="(zagent, index) in zholdagents.filter(a => a.department == zdepartment)" :key="index">
                <span @click="change_agent(zagent.agent)" :id="zagent.agent + '_' + zagent.department + '_1'">
                  <b-avatar class="mr-1 z-auto" :text="zagent.agent" :badge="zagent.count"
                    badge-variant="orange"></b-avatar>
                </span>
                <b-tooltip :target="zagent.agent + '_' + zagent.department + '_1'" placement="bottom">{{ zagent.name }}
                </b-tooltip>
              </div>

            </b-avatar-group>
          </b-col>
        </b-row>

        <div class="mt-4 availtable datatable">
          <b-card v-if="zhold.filter" class="w-100pct mb-3">
            <b-card-body class="py-0">

              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                    <b-input-group>
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="slac" :clearable="true" :multiple="true" :async="true"
                        :load-options="treeselect_loadSLAC" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Event" label-size="sm">
                    <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                      v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                      :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                      :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="Your Ref P/O" label-for="yourref" label-cols="12">
                    <b-input-group class="z-0">
                      <b-form-tags input-id="yourref" v-model="yourref" tag-variant="primary" separator=" ,;"
                        placeholder="Paste Yourref (333..,333...)" size="sm" class="h-29" add-button-text="+"
                        add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="yourref = []">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="Ticket No" label-for="reflist1" label-cols="12">
                    <b-input-group class="z-0">
                      <b-form-tags input-id="reflist1" v-model="ticketno" tag-variant="primary" separator=" ,;"
                        placeholder="Paste Ref (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                        remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="ticketno = []">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-tooltip target="reflist1-tooltip" triggers="hover">Use ticket number in related fields? Check this
                    option to see
                    associated exchange and re-issued tickets.
                  </b-tooltip>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <!-- <b-col cols="auto"> -->
                  <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                    <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                    <b-input-group>
                      <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                        :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                        :single-date-picker="'range'">
                      </daterangepicker>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                          datetravel = {
                            startDate: null,
                            endDate: null,
                          }
                          ">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Passenger" label-size="sm">
                    <b-input-group>
                      <b-form-input v-model="passenger" placeholder="Passenger" trim></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ticket Source" label-size="sm">
                  <treeselect placeholder="Select source..." v-model="mssql" :clearable="false"
                    :options="options_ticketsource" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col> -->
              </b-row>
            </b-card-body>
          </b-card>
        </div>
        <!-- {{ zhold.groupbyitinerary }} -->
        <div class="px-3 mt-2 mb-2">
          <e-table classdivtable="availtable datatable w-100pct" refid="zhold" :busy="zhold.busy" :icon="zhold.icon"
            :selectmode="'none'" :showtoolbar="true" :showfab="false" :showsheets="false" :showrowcount="true"
            :showautoadd="false" :showpages="true" :offset="zhold.offset" :limit="zhold.limit" :page="zhold.page"
            :toolbarlibrary="zhold.toolbarlibrary" :tools="zhold.tools" :badges="zhold.badges" :fields="zhold.fields"
            :items="zhold.items" @click="zhold_click" @select="zhold_select" @load="zhold_load">
          </e-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="zhold.selected" :config="cconfig" @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"></component>
      </div>
      <b-card-footer>
        <b-row class="mt-2">
          <b-col><span class="small" v-html="message"></span> </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Zhold",
  async mounted() {
    this.accessdenied();
    await this.zhold_reset()
    // await this.zholdclients_load()
    this.agent = this.user.initials;
  },
  watch: {
    async issued_at() {
      await this.zhold_load();
    },
    async flightno() {
      await this.zhold_load();
    },
    async ticketno() {
      await this.zhold_load();
    },
    async yourref() {
      await this.zhold_load();
    },
    async passenger() {
      await this.zhold_load();
    },
    async slaclike_visible() {
      await this.zhold_load();
    },
    async routing() {
      await this.zhold_load();
    },
    async slac() {
      await this.zhold_load();
    },
    async slaclike() {
      await this.zhold_load();
    },
    async invoiceno() {
      await this.zhold_load();
    },
    async locator() {
      await this.zhold_load();
    },
    async datetravel() {
      await this.zhold_load();
    },
    async eventcode() {
      await this.zhold_load();
    },
    async agent() {
      await this.zhold_load();
    },
  },

  data() {
    return {
      busy: false,
      message: "",
      ztotal: 0,
      zholdclients: [],
      zholdevents: [],
      zholdagents: [],
      departments: [],
      readonly: false,
      eventcode: [],
      slac: [],
      ticketno: [],
      yourref: [],
      datetravel: {
        startDate: null,
        endDate: null,
      },
      passenger: null,
      agent: null,
      mssql: true,
      options_ticketsource: [
        { id: false, label: "Ticket Table" },
        { id: true, label: "Ticket Repository" },
      ],
      zhold: {
        title: "Zhold Invoicing",
        icon: "fa fa-ticket text-orange",
        debounce: 1000,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter,groupbyitinerary",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-sort-numeric-asc text-orange",
            position: "toolbar",
            action: "groupbyitinerary",
            label: "Group By Itinerary On",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "zitem",
            label: "Zhold Inventory",
            type: "izinvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        groupbyitinerary: true
      },
    };
  },
  methods: {
    accessdenied() {
      this.zhold.denied = [];
      if (!this.user.permissions.includes("zhold.delete")) {
        this.zhold.denied.push("delete");
      }
      if (!this.user.permissions.includes("zhold.save")) {
        this.zhold.denied.push("save");
      }
    },
    async change_agent(agent) {
      this.agent = agent
      await this.zhold_load();
    },
    async zhold_reset() {
      let state = this.zhold;
      state.items = []
      this.eventcode = []
      this.slac = []
      //this.agent = null
      await this.zholdevents_load()
      await this.zholdclients_load()
      await this.zholdagents_load()
    },
    async zhold_reload() {
      await this.zholdevents_load()
      await this.zholdclients_load()
      await this.zholdagents_load()
      await this.zhold_load();
    },
    async zholdevents_load() {
      let variables = {
        type: 'byevent',
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query tickets_zholdcounts(
                  $type: String
                  $agent: String
              ) {
                  tickets_zholdcounts(
                      type: $type
                      agent: $agent
              ) {
                  count
                  aged
                  eventcode
                  name
              }
              }
          `,
          variables,
        });

        this.zholdevents = response.data.tickets_zholdcounts;
        // this.ztotal = 0
        // for (var i = 0; i < this.zholdclients.length; ++i) {
        //   this.ztotal += parseInt(this.zholdclients[i].count)
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async zholdclients_load() {
      let variables = {
        type: 'byclient',
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query tickets_zholdcounts(
                  $type: String
                  $agent: String
              ) {
                  tickets_zholdcounts(
                      type: $type
                      agent: $agent
              ) {
                  count
                  aged
                  slac
                  name
              }
              }
          `,
          variables,
        });

        this.zholdclients = response.data.tickets_zholdcounts;
        this.ztotal = 0
        for (var i = 0; i < this.zholdclients.length; ++i) {
          this.ztotal += parseInt(this.zholdclients[i].count)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async zholdagents_load() {
      let variables = {
        type: 'byagent',
        eventcode: this.eventcode ? this.eventcode.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query tickets_zholdcounts(
                  $type: String
                  $eventcode: String
                  $slac: String
              ) {
                  tickets_zholdcounts(
                      type: $type
                      eventcode: $eventcode
                      slac: $slac
              ) {
                  count
                  agent
                  email
                  name
                  department
              }
              }
          `,
          variables,
        });

        this.zholdagents = response.data.tickets_zholdcounts;
        this.ztotal = 0
        for (var i = 0; i < this.zholdclients.length; ++i) {
          this.ztotal += parseInt(this.zholdclients[i].count)
        }
      } catch (error) {
        console.log(error);
      }


      this.departments = [...new Set(this.zholdagents.map(a => a.department))].sort()


    },
    async zhold_load(offset, limit, page) {

      let state = this.zhold;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      //NO WILDCARD SEARCHES
      if (
        !this.agent && this.slac.length == 0 && this.eventcode.length == 0
      ) {
        this.message = ""
        return;
      }

      state.busy = true;

      if (state.groupbyitinerary) {

        let variables = {
          offset,
          limit: limit ? limit : this.limit,
          eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
          slac: this.slac.length > 0 ? this.slac.join(",") : null,
          ticketno: this.ticketno.length > 0 ? this.ticketno.join(",") : null,
          yourref: this.yourref.length > 0 ? this.yourref.join(",") : null,
          passenger: this.passenger,
          datetravel: [
            this.datetravel.startDate
              ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
              : null,
            this.datetravel.endDate
              ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
              : null,
          ],
          agent: this.agent,
        };
        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
            query zhold(
              $offset: Int
              $limit: Int
              $eventcode: String
              $slac: String
              $ticketno: String
              $yourref: String
              $datetravel: [String]
              $passenger: String
              $agent: String
            ) {
              zhold(
                offset: $offset
                limit: $limit
                eventcode: $eventcode
                slac: $slac
                ticketno: $ticketno
                yourref: $yourref
                datetravel: $datetravel
                passenger: $passenger
                agent: $agent
              ) {
                id
                eventcode
                eventname
                slac
                slacname
                passengers {
                  id
                  ticketno
                  tickets {
                    id
                    issued_at
                    ticketno
                    type
                    passenger
                  }
                  passenger
                  yourref
                  include
                }
                sectors {
                  id
                  type
                  agent
                  issued_at
                  eventcode
                  slac
                  locator
                  route
                  aircraft
                  flightno
                  start_at
                  end_at
                  # startdate
                  # starttime
                  startcity
                  endcity
                  description
                  cabin
                  class
                  fare
                  tax
                  total
                  markup
                  tickets {
                    id
                    issued_at
                    ticketno
                    type
                    passenger
                  }
                  include
                  expanded
                }
                fare
                tax
                total
                markup
                fee
                queued
                notes
                robot
                cssname
                tags
                data
                rows
              }
            }
          `,
            variables,
          });

          // USE LOCAL VARIABLE
          if (limit == 0) {
            state.selected = response.data.zhold
          } else {
            state.items = []
            // STABLE ROW IDENTITY (tp_server#20): key each booking by its ticket ids so
            // e-table can key rows by record, not position - prevents inline-editor
            // state (PO / Your Ref) bleeding onto other rows when paging.
            response.data.zhold.forEach(row => {
              let ids = [];
              (row.sectors || []).forEach(s => (s.tickets || []).forEach(t => {
                if (t.id != null) ids.push(t.id);
              }));
              row.uid = [...new Set(ids)].sort().join('-');
            });
            state.items = response.data.zhold;
          }

        } catch (error) {
          console.log(error);
        }

      } else {

        let variables = {
          offset,
          limit: limit ? limit : this.limit,
          eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
          slac: this.slac.length > 0 ? this.slac.join(",") : null,
          // blac: this.blac.length > 0 ? this.blac.join(",") : null,
          referenceno: this.ticketno.length > 0 ? this.ticketno.join(",") : null,
          // token: this.token.length > 0 ? this.token.join(",") : null,
          // status: this.status.length > 0 ? this.status.join(",") : null,
          // type: this.type.length > 0 ? this.type.join(",") : null,
          datetravel: [
            this.datetravel.startDate
              ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
              : null,
            this.datetravel.endDate
              ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
              : null,
          ],
          agent: this.agent,
          source: 'zhold',
          // cost: this.cost.min ? [this.cost.min, this.cost.max] : null,
        };

        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query ihold(
                $offset: Int
                $limit: Int
                $groupby: String
                $eventcode: String
                $slac: String
                $blac: String
                $type: String
                $datetravel: [String]
                $referenceno: String
                $reference: String
                $status: String
                $source:String
                $agent: String
                $cost: [String]
              ) {
                ihold(
                  offset: $offset
                  limit: $limit
                  groupby: $groupby
                  eventcode: $eventcode
                  slac: $slac
                  blac: $blac
                  type: $type
                  datetravel: $datetravel
                  referenceno: $referenceno
                  reference: $reference
                  status: $status
                  source: $source
                  agent: $agent
                  cost: $cost
                ) {
                  id
                  referenceno
                  blac                  
                  eventcode
                  eventname
                  slac
                  slacname
                  yourref
                  cost
                  sale
                  vat
                  margin
                  markup
                  total
                  invoiceno
                  posted
                  notes
                  agent
                  lines {
                    id
                    type
                    issued_at
                    last4
                    token
                    referenceno
                    reference
                    routing
                    remark               
                    locator
                    start_at
                    end_at
                    startcity
                    endcity
                    flightno
                    aircraft
                    cabin
                    class
                    details
                    description
                    passenger
                    qty
                    fare
                    tax
                    sale
                    vat
                    markup
                    total
                    costlocal
                    costlocalcurrency
                    costcurrency                
                    cost
                    blac
                    slac
                    eventcode
                    margin
                    agent
                    agentname
                    notes
                    expanded
                    claimed
                  }
                  robot
                  cssname
                  tags
                  data
                  groupby
                  rows
                }
              }
            `,
            variables,
          });

          // USE LOCAL VARIABLE
          if (limit == 0) {
            state.selected = response.data.ihold
          } else {
            state.items = []
            // STABLE ROW IDENTITY (tp_server#20) - see the zhold path above.
            response.data.ihold.forEach(row => {
              let ids = [];
              (row.lines || []).forEach(l => { if (l.id != null) ids.push(l.id); });
              row.uid = [...new Set(ids)].sort().join('-');
            });
            state.items = response.data.ihold;
          }

        } catch (error) {
          console.log(error);
        }

      }

      await this.zholdclients_load()
      await this.zholdagents_load()

      state.busy = false;
    },

    async zhold_click(a, ss, tools) {
      console.log("zhold_click", a, ss);

      let state = this.zhold;

      let tool = null

      switch (a) {
        case "filter":
          state.filter = !state.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "queued":
          this.queueit(ss);
          break;
        case "go":
          await this.zhold_reload();
          break;
        case "groupbyitinerary":
          tool = tools.find((o) => o.action == a);
          state.groupbyitinerary = !state.groupbyitinerary
          if (state.groupbyitinerary) {
            tool.label = "Group By Itinerary On"
            state.fields = [
              {
                key: "zitem",
                label: "Zhold Inventory",
                type: "izinvoice",
                class: "text-left w-90pct",
                clearable: "true",
              },
            ]
          } else {
            tool.label = "Group By Itinerary Off"
            state.fields = [
              {
                key: "titem",
                label: "Zhold Inventory",
                type: "itinvoice",
                class: "text-left w-90pct",
                clearable: "true",
              },
            ]
          }
          await this.zholdagents_load()
          await this.zhold_load();
          break;
      }
    },
    async zhold_select(ss, tools) {
      console.log("zhold_click", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "autoquery", "filter", "export", "groupbyitinerary"];
        //let enabled = ["back", "save", "go", "autoquery", "filter", "export", ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.zhold.selected = ss;
    },
    async queueit(s) {
      console.log("queueit", s);
      s[0].queued = true
      console.log(s)
    },
    async deleteit(s) {
      console.log("deleteit", s);

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_delete($rows: [Ticket_input]) {
              tickets_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.load();
    },
    async downloadit() {
      this.busy = true;

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        documentformat: this.documentformat,
        dateformat: "YYYY-MM-DD",
      };
      console.log("download variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query zhold(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $documentformat: String
              $dateformat: String
            ) {
              zhold(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                documentformat: $documentformat
                dateformat: $dateformat
              ) {
                documentname
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.zhold.length > 0) {
          try {
            this.fileUpload = JSON.parse(response.data.zhold[0].data);
          } catch (error) {
            // this.fileUpload = {
            //   name: response.data.orders[0].yourref + ".pdf",
            //   data: response.data.orders[0].data,
            // };
          }
          await this.fileUpload_view();
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async postit(s) {
      console.log("postit", s);
      s[0].posted = true
      await this.zholdclients_load()
      this.$store.dispatch("zhold");
    },
  },
};
</script>